import { render } from "./Navbar2.vue?vue&type=template&id=6c93ba04&scoped=true"
import script from "./Navbar2.vue?vue&type=script&lang=js"
export * from "./Navbar2.vue?vue&type=script&lang=js"

import "./Navbar2.vue?vue&type=style&index=0&id=6c93ba04&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c93ba04"]])

export default __exports__